// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2dl9b","range":"MonthRangeSwitch_range__22zMz","disabled":"MonthRangeSwitch_disabled__2eHjG"};